import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils";

import { theme } from "../../theme/css/theme.css";
import { disabledState } from "../../theme/disabledState";

export const askAIButtonStyle = style({
  color: theme.colors.placeholder,
  cursor: "pointer",
  height: rem(36),
  ":hover": {
    color: theme.colors.primary,
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    textDecorationColor: theme.colors.primary,
    textDecorationThickness: "2px",
    textDecorationStyle: "solid",
    textDecorationLine: "underline",
  },
  ":disabled": disabledState,
  selectors: {
    "&[data-disabled]": disabledState,
  },
});
